import React from 'react'


export const HeaderNav = () => {
  return (
    <header className='header'>
        <a href='https://signore.netlify.app/'> Signore (Demo)</a>

    </header>
  )
}
